import {
  DEFAULT_PAGE_WIDTH,
  Divider,
  SkeletonView,
} from "@towersystems/roam-common-native";
import { Spacings, View } from "react-native-ui-lib";

export interface FlatListSearchableSkeletonProps {
  searchbar?: boolean;
  rows?: number;
}

export const FlatListSearchableSkeleton = ({
  searchbar = true,
  rows = 5,
}: FlatListSearchableSkeletonProps) => {
  const searchBarMarkup = searchbar ? (
    <View>
      <SkeletonView style={{ width: "100%" }} height={55} />
      <Divider width={2} marginBottom={Spacings.s6} />
    </View>
  ) : null;

  const rowsMarkup = Array.from({ length: rows }).map((_, index) => (
    <View key={index} centerV style={{ paddingHorizontal: Spacings.s4 }}>
      <View
        style={{
          justifyContent: "space-between",
          flexDirection: "row",
          paddingVertical: Spacings.s6,
        }}
      >
        <View>
          <SkeletonView
            textVariant="heading"
            width={220}
            style={{ marginBottom: Spacings.s4 }}
          />
          <SkeletonView textVariant="heading" style={{ width: 150 }} />
        </View>
        <View style={{ alignItems: "flex-end" }}>
          <SkeletonView textVariant="heading" width={80} />
        </View>
      </View>
      {index !== rows - 1 ? <Divider width={1} marginVertical={0} /> : null}
    </View>
  ));

  return (
    <View
      style={{
        maxWidth: DEFAULT_PAGE_WIDTH,
        alignSelf: "center",
        width: "100%",
      }}
      flex
    >
      {searchBarMarkup}
      {rowsMarkup}
    </View>
  );
};
